var map = {
	"./bgmap1.png": "7ee9",
	"./bgmap2.png": "bd86",
	"./centerBack.png": "a075",
	"./pad1.png": "d477",
	"./pad10.png": "d352",
	"./pad11.png": "a0bd",
	"./pad12.png": "87a8",
	"./pad2.png": "4d59",
	"./pad3.png": "308d",
	"./pad4.png": "8432",
	"./pad5.png": "9a93",
	"./pad6.png": "b29a",
	"./pad7.png": "4ed1",
	"./pad8.png": "43b9",
	"./pad9.png": "da8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "28c2";